import { useEffect } from 'react';
import { useThemeStore } from '@core/theme/useThemeStore';
import {
  applyActionThemeToElement,
  clearActionThemeFromElement,
} from '@core/theme/actionTheme.util';

/**
 * Syncs tenant action colours to :root CSS variables for use across the app.
 */
export const ActionThemeSync = () => {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;
    applyActionThemeToElement(root, theme);
    return () => clearActionThemeFromElement(root);
  }, [theme]);

  return null;
};
